module.exports = __webpack_public_path__ + "img/live_defult.905c6896.png";